(function () {
'use strict';
if (window.MADDOX_TRACKING_V3_INITIALISED === true) return;
window.MADDOX_TRACKING_V3_INITIALISED = true;
var VERSION = 'V3';
var CONFIG = window.MADDOX_TRACKING_CONFIG || {};
var PAGE = window.MADDOX_PAGE_CONTEXT || {};
var STORAGE = {
anonymousId: 'maddox_anonymous_id_v3',
session: 'maddox_session_v3',
firstSeen: 'maddox_first_seen_v3',
firstTouch: 'maddox_first_touch_v3',
latestTouch: 'maddox_latest_touch_v3',
sessionTouch: 'maddox_session_touch_v3',
latestMeaningfulTouch: 'maddox_latest_meaningful_touch_v3',
knownProfile: 'maddox_known_profile_v3',
eventDedupe: 'maddox_event_dedupe_v3',
formState: 'maddox_form_state_v3',
artworkHistory: 'maddox_artwork_history_v3',
consentGranted: 'maddox_consent_granted_v3'
};
var SESSION_TIMEOUT_MS = 30 * 60 * 1000;
var DEBUG = CONFIG.debug === true || /(?:^|[?&])maddox_debug=1(?:&|$)/.test(window.location.search || '');
var FORM_ID_MAPPINGS = CONFIG.formIdMappings || {};
var FORM_FIELD_MAPPINGS = CONFIG.formFieldMappings || {};
var startedForms = {};
var submittedForms = {};
var viewedForms = {};
var ctaMemory = {};
var FORM_STATE_TTL_MS = 24 * 60 * 60 * 1000;
var eventDedupe = readJson(localStorage, STORAGE.eventDedupe, {});
var APPROVED_KLAVIYO_EVENTS = {
identity_identified: true,
lead_form_viewed: true,
lead_form_started: true,
lead_form_error_seen: true,
lead_form_abandoned: true,
lead_form_submitted: true,
marketing_consent_granted: true,
soft_lead_created: true,
artwork_enquiry_submitted: true,
artist_enquiry_submitted: true,
exhibition_enquiry_submitted: true,
advisory_form_submitted: true,
document_requested: true,
investment_document_requested: true,
consignment_enquiry_submitted: true,
artist_submission_received: true,
article_viewed: true,
article_tag_viewed: true,
article_cta_clicked: true,
article_internal_link_clicked: true,
artist_page_viewed: true,
artwork_viewed: true,
repeat_artwork_viewed: true,
advisory_page_viewed: true,
exhibition_page_viewed: true,
document_page_viewed: true,
collection_viewed: true,
site_search_performed: true,
cta_clicked: true,
high_intent_cta_clicked: true,
appointment_cta_clicked: true,
appointment_booked: true,
booking_started: true,
chatbot_lead_created: true,
phone_number_clicked: true,
email_link_clicked: true,
whatsapp_clicked: true,
gallery_location_viewed: true,
directions_clicked: true,
known_lead_returned: true
};
var HIDDEN_FIELDS = [
'anonymous_id', 'session_id', 'submission_id', 'event_id',
'first_seen_source', 'first_seen_medium', 'first_seen_campaign', 'first_seen_content', 'first_seen_term', 'first_seen_landing_page',
'first_seen_referrer', 'first_seen_timestamp',
'first_touch_source', 'first_touch_medium', 'first_touch_campaign', 'first_touch_content', 'first_touch_term', 'first_touch_landing_page',
'first_touch_referrer', 'first_touch_timestamp',
'lead_create_source', 'lead_create_medium', 'lead_create_campaign', 'lead_create_content', 'lead_create_term',
'lead_create_landing_page', 'lead_create_page', 'lead_create_timestamp',

'latest_touch_source', 'latest_touch_medium', 'latest_touch_campaign', 'latest_touch_content', 'latest_touch_term',
'latest_touch_timestamp',
'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term',
'gclid', 'gbraid', 'wbraid', 'fbclid', 'msclkid', 'ttclid', 'linkedin_click_id',
'channel_group', 'sub_channel', 'ai_referrer', 'referral_partner', 'offline_sub_source',
'page_url', 'page_path', 'page_title', 'page_type', 'entity_type', 'entity_id', 'entity_name',
'artwork_id', 'artwork_title', 'artist_name', 'price', 'price_band', 'product_url', 'shopify_product_id', 'shopify_variant_id', 'edition_or_series',
'medium', 'year', 'dimensions',
'artist_id', 'artist_slug', 'artist_page_url',
'article_id', 'article_title', 'article_primary_tag', 'article_secondary_tag', 'article_third_tag',
'document_id', 'document_title', 'document_type', 'document_topic', 'document_category', 'document_url',
'marketing_consent', 'process_consent', 'consent_source', 'consent_timestamp',
'self_reported_source', 'lead_type', 'form_intent', 'form_name'
];
var ALIASES = {
Email: 'email', email_address: 'email', contact_email: 'email', customer_email: 'email', '$email': 'email',
FirstName: 'first_name', firstName: 'first_name', firstname: 'first_name', 'First Name': 'first_name', '$first_name': 'first_name',
LastName: 'last_name', lastName: 'last_name', lastname: 'last_name', 'Last Name': 'last_name', '$last_name': 'last_name',
Phone: 'phone', phone_number: 'phone', phoneNumber: 'phone', '$phone_number': 'phone',
Message: 'message', messageText: 'message', enquiry_message: 'message',
artwork: 'artwork_title', Artwork: 'artwork_title', artwork_name: 'artwork_title', artworkName: 'artwork_title', product_title: 'artwork_title',
artist: 'artist_name', Artist: 'artist_name', artistName: 'artist_name',
document_name: 'document_title', documentTitle: 'document_title', document: 'document_title',
budget: 'budget_range', Budget: 'budget_range', investment_timing: 'investment_interest', investmentTiming: 'investment_interest',
accepts_marketing: 'marketing_consent', marketingConsent: 'marketing_consent', marketing_consent: 'marketing_consent',
processing_consent: 'process_consent', processConsent: 'process_consent', process_consent: 'process_consent',
how_did_you_hear_about_us: 'self_reported_source', selfReportedSource: 'self_reported_source'
};
function log() {
if (!DEBUG || !window.console) return;
var args = Array.prototype.slice.call(arguments);
args.unshift('[MaddoxTracking V3]');
window.console.log.apply(window.console, args);
}
function nowIso() {
return new Date().toISOString();
}
function uuid(prefix) {
var value = '';
if (window.crypto && typeof window.crypto.randomUUID === 'function') value = window.crypto.randomUUID();
else value = Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 12);
return prefix ? prefix + '_' + value : value;
}
function text(value, max) {
if (value === undefined || value === null) return '';
return String(value).replace(/\s+/g, ' ').trim().slice(0, max || 500);
}
function readJson(storage, key, fallback) {
try {
var raw = storage.getItem(key);
if (!raw) return fallback;
return JSON.parse(raw);
} catch (e) {
return fallback;
}
}
function writeJson(storage, key, value) {
try {
storage.setItem(key, JSON.stringify(value));
} catch (e) {}
}
function getParam(name) {
try {
return new URLSearchParams(window.location.search || '').get(name) || '';
} catch (e) {
return '';
}
}
function getPath() {
return window.location.pathname || '';
}
function getDeviceType() {
var width = window.innerWidth || document.documentElement.clientWidth || 0;
if (width <= 767) return 'mobile';

if (width <= 1024) return 'tablet';
return 'desktop';
}
function getBrowser() {
var ua = navigator.userAgent || '';
if (/Edg\//.test(ua)) return 'Edge';
if (/CriOS/.test(ua)) return 'Chrome iOS';
if (/Chrome\//.test(ua) && /Safari\//.test(ua)) return 'Chrome';
if (/Safari\//.test(ua) && !/Chrome\//.test(ua)) return 'Safari';
if (/Firefox\//.test(ua)) return 'Firefox';
return '';
}
function bool(value, fallback) {
if (value === undefined || value === null || value === '') return !!fallback;
if (value === true || value === 'true' || value === '1' || value === 'yes' || value === 'on') return true;
if (value === false || value === 'false' || value === '0' || value === 'no' || value === 'off') return false;
return !!fallback;
}
function normaliseFieldName(name) {
var value = String(name || '').trim();
var bracket = value.match(/^(contact|customer|form|properties|attributes)\[([^\]]+)\]$/i);
if (bracket && bracket[2]) value = bracket[2];
value = value.replace(/\[([^\]]+)\]/g, '_$1').replace(/[.\s-]+/g, '_').replace(/__+/g, '_').replace(/^_+|_+$/g, '');
return ALIASES[value] || ALIASES[value.toLowerCase()] || value;
}
function queryFormField(form, names) {
for (var i = 0; i < names.length; i += 1) {
var n = names[i];
var field = null;
try {
field = form.querySelector('[name="' + n + '"], [id="' + n + '"]');
} catch (e) {}
var value = readFieldValue(field);
if (value !== undefined && value !== null && value !== '') return value;
}
return '';
}
function readFieldValue(field) {
if (!field) return '';
var type = (field.getAttribute('type') || '').toLowerCase();
if (type === 'checkbox') return field.checked;
if (type === 'radio') return field.checked ? field.value : undefined;
if (type === 'file') return '';
if (field.tagName && field.tagName.toLowerCase() === 'select' && field.multiple) {
return Array.prototype.slice.call(field.selectedOptions || []).map(function (o) { return o.value; }).join(', ');
}
return field.value || '';
}
function findLabel(form, field) {
if (!field) return '';
var id = field.id || '';
var label = '';
if (id && form && form.querySelector) {
try {
var found = form.querySelector('label[for="' + id.replace(/"/g, '\\"') + '"]');
label = text(found && found.textContent || '', 160);
} catch (e) {}
}
if (!label && field.closest) label = text(field.closest('label') && field.closest('label').textContent || '', 160);
if (!label) label = text(field.getAttribute('aria-label') || field.getAttribute('placeholder') || field.name || field.id || '', 160);
return label;
}
function isSensitiveField(field) {
var haystack = [field.name, field.id, field.getAttribute('autocomplete'), field.getAttribute('aria-label'), field.getAttribute('placeholder')].join(' ');

return /(password|pwd|pass|card|credit|debit|cvv|cvc|expiry|expiration|payment|token|auth|csrf|captcha|recaptcha|h-captcha|g-recaptcha|secret|signature|session|cookie|checkout)/i.test(haystack);

}
function getAnonymousId() {
var id = '';
try {
id = localStorage.getItem(STORAGE.anonymousId) || '';
if (!id) {
id = uuid('anon');
localStorage.setItem(STORAGE.anonymousId, id);

maddoxTrack('anonymous_id_created', { anonymous_id: id, first_seen_timestamp: nowIso() }, { klaviyo: false, dedupe_seconds: 86400
});
}
} catch (e) {
id = uuid('anon');
}
return id;
}
function getSession() {
var session = readJson(sessionStorage, STORAGE.session, null);
var now = Date.now();
if (!session || !session.session_id || !session.last_seen_at_ms || now - session.last_seen_at_ms > SESSION_TIMEOUT_MS) {
session = { session_id: uuid('ses'), started_at: nowIso(), started_at_ms: now, last_seen_at_ms: now, landing_page: window.location.href,
landing_path: getPath(), page_count: 0 };
writeJson(sessionStorage, STORAGE.session, session);
maddoxTrack('session_started', { session_id: session.session_id, landing_page: session.landing_page, landing_path:
session.landing_path }, { klaviyo: false, dedupe_seconds: 60 });
} else {
session.last_seen_at_ms = now;
writeJson(sessionStorage, STORAGE.session, session);
}
return session;
}
function incrementSessionPageCount() {
var session = getSession();
session.page_count = (session.page_count || 0) + 1;
session.last_seen_at_ms = Date.now();
writeJson(sessionStorage, STORAGE.session, session);
return session.page_count;
}
function rawAttribution() {
return {
source: getParam('utm_source'),
medium: getParam('utm_medium'),
campaign: getParam('utm_campaign'),
content: getParam('utm_content'),
term: getParam('utm_term'),
gclid: getParam('gclid'),
gbraid: getParam('gbraid'),
wbraid: getParam('wbraid'),
fbclid: getParam('fbclid'),
msclkid: getParam('msclkid'),
ttclid: getParam('ttclid'),
linkedin_click_id: getParam('li_fat_id') || getParam('linkedin_click_id'),
referrer: document.referrer || '',
page_url: window.location.href,
page_path: getPath(),
timestamp: nowIso()
};
}
function hasMeaningfulAttribution(attr) {
if (!attr) return false;
if (attr.source || attr.medium || attr.campaign || attr.content || attr.term || attr.gclid || attr.gbraid || attr.wbraid || attr.fbclid || attr.msclkid ||
attr.ttclid || attr.linkedin_click_id) return true;
if (!attr.referrer) return false;
try {
return new URL(attr.referrer).hostname !== window.location.hostname;
} catch (e) {
return true;
}
}
function isPlaceholderAttribution(attr) {
attr = attr || {};
var vals = [attr.source, attr.medium, attr.campaign, attr.content, attr.term]
.map(function (v) { return String(v || '').toLowerCase().trim(); })
.filter(Boolean);
if (!vals.length) return false;
var placeholders = { source: true, medium: true, campaign: true, content: true, term: true,
test: true, testing: true, qa: true, 'qa-test': true, example: true, sample: true, placeholder: true };
return vals.every(function (v) {
return placeholders[v] === true || /^test[-_ ]/.test(v) || /^qa[-_ ]/.test(v);
});
}
function preferMeaningfulTouch(primary, fallback) {
if (primary && hasMeaningfulAttribution(primary) && !isPlaceholderAttribution(primary)) return primary;
if (fallback && hasMeaningfulAttribution(fallback) && !isPlaceholderAttribution(fallback)) return fallback;
if (primary && hasMeaningfulAttribution(primary)) return primary;

if (fallback && hasMeaningfulAttribution(fallback)) return fallback;
return primary || fallback || null;
}
function classifyChannel(attr) {
attr = attr || {};
var source = String(attr.source || '').toLowerCase();
var medium = String(attr.medium || '').toLowerCase();
var campaign = String(attr.campaign || '').toLowerCase();
var referrer = String(attr.referrer || '').toLowerCase();
var host = '';
try { host = referrer ? new URL(referrer).hostname.replace(/^www\./, '') : ''; } catch (e) {}
var out = { channel_group: 'Direct Traffic', sub_channel: '', ai_referrer: '', referral_partner: '', offline_sub_source: '' };
if (/offline|qr|gallery|event|fair|private_view|pv/.test(source + ' ' + medium + ' ' + campaign)) {
out.channel_group = 'Offline';
out.offline_sub_source = source || campaign || medium;
return out;
}
if (/affiliate|partner/.test(medium) || /affiliate|partner/.test(source)) {
out.channel_group = 'Affiliate';
out.referral_partner = source || host;
return out;
}
if (/email|e-mail|klaviyo/.test(medium) || /klaviyo|mailchimp|email/.test(source)) {
out.channel_group = 'Email';
out.sub_channel = source || 'email';
return out;
}
if (attr.gclid || attr.gbraid || attr.wbraid || /cpc|ppc|paidsearch|paid_search|sem/.test(medium)) {
out.channel_group = 'Paid Search';
out.sub_channel = source || 'google';
return out;
}
if (attr.fbclid || attr.ttclid || attr.linkedin_click_id || /paid_social|paidsocial|social_paid/.test(medium)) {
out.channel_group = 'Paid Social';
out.sub_channel = source || 'paid_social';
return out;
}
if (/instagram|facebook|tiktok|pinterest|linkedin|twitter|x\.com/.test(source + ' ' + host)) {
out.channel_group = /paid/.test(medium) ? 'Paid Social' : 'Organic Social';
out.sub_channel = source || host;
return out;
}
if (/chatgpt|openai|perplexity|claude|gemini|copilot|bingchat|you\.com/.test(source + ' ' + host)) {
out.channel_group = 'AI Referrals';
out.ai_referrer = source || host;
return out;
}
if (/google|bing|yahoo|duckduckgo|ecosia/.test(host) && !medium) {
out.channel_group = 'Organic Search';
out.sub_channel = host;
return out;
}
if (/organic/.test(medium) && /search/.test(medium)) {
out.channel_group = 'Organic Search';
out.sub_channel = source;
return out;
}
if (/referral/.test(medium) || host) {
out.channel_group = 'Referral';
out.referral_partner = source || host;
return out;
}
if (isPlaceholderAttribution(attr)) {
out.channel_group = 'QA / Test';
out.sub_channel = source || medium || 'test';
return out;
}
if (source || medium || campaign || attr.content || attr.term ||
attr.gclid || attr.gbraid || attr.wbraid || attr.fbclid ||
attr.msclkid || attr.ttclid || attr.linkedin_click_id) {
// Exclude the sentinel 'direct' values injected by currentTouch() for
// no-attribution visits — they are not real campaign signals
var isDirect = source === 'direct' && medium === 'direct' && !campaign &&
!attr.content && !attr.term && !attr.gclid && !attr.gbraid && !attr.wbraid &&
!attr.fbclid && !attr.msclkid && !attr.ttclid && !attr.linkedin_click_id && !host;
if (!isDirect) {
out.channel_group = 'Campaign / Other';
out.sub_channel = source || medium || '';
return out;
}
}
return out;

}
function completeTouch(attr, fallbackSource, fallbackMedium) {
attr = attr || {};
var touch = {
source: attr.source || fallbackSource || '',
medium: attr.medium || fallbackMedium || '',
campaign: attr.campaign || '',
content: attr.content || '',
term: attr.term || '',
gclid: attr.gclid || '',
gbraid: attr.gbraid || '',
wbraid: attr.wbraid || '',
fbclid: attr.fbclid || '',
msclkid: attr.msclkid || '',
ttclid: attr.ttclid || '',
linkedin_click_id: attr.linkedin_click_id || '',
referrer: attr.referrer || '',
page_url: attr.page_url || window.location.href,
page_path: attr.page_path || getPath(),
timestamp: attr.timestamp || nowIso()
};
return Object.assign(touch, classifyChannel(touch));
}
function currentTouch() {
var raw = rawAttribution();
if (hasMeaningfulAttribution(raw)) return completeTouch(raw, '', '');
return completeTouch(raw, raw.source || 'direct', raw.medium || 'direct');
}
function captureAttribution() {
var touch = currentTouch();
var meaningful = hasMeaningfulAttribution(touch);
var firstSeen = readJson(localStorage, STORAGE.firstSeen, null);
if (!firstSeen) {
writeJson(localStorage, STORAGE.firstSeen, touch);
maddoxTrack('first_seen_captured', prefixAttribution('first_seen', touch), { klaviyo: false, dedupe_seconds: 86400 });
}
var firstTouch = readJson(localStorage, STORAGE.firstTouch, null);
var isDirect = touch.source === 'direct' && touch.medium === 'direct' &&
!touch.campaign && !touch.content && !touch.term &&
!touch.gclid && !touch.gbraid && !touch.wbraid && !touch.fbclid &&
!touch.msclkid && !touch.ttclid && !touch.linkedin_click_id && !touch.referrer;
var meaningfulAndReal = meaningful && !isPlaceholderAttribution(touch) && !isDirect;
if (!firstTouch && meaningfulAndReal) {
writeJson(localStorage, STORAGE.firstTouch, touch);
maddoxTrack('first_touch_captured', prefixAttribution('first_touch', touch), { klaviyo: false, dedupe_seconds: 86400 });
}
var sessionTouch = readJson(sessionStorage, STORAGE.sessionTouch, null);
if (!sessionTouch || meaningful) writeJson(sessionStorage, STORAGE.sessionTouch, touch);
if (meaningful && !isPlaceholderAttribution(touch) && !isDirect) {
writeJson(localStorage, STORAGE.latestMeaningfulTouch, touch);
maddoxTrack('latest_touch_updated', prefixAttribution('latest_touch', touch), { klaviyo: false, dedupe_seconds: 60 });
}
if (touch.gclid || touch.gbraid || touch.wbraid || touch.fbclid || touch.msclkid || touch.ttclid || touch.linkedin_click_id)
maddoxTrack('click_id_captured', Object.assign(clickIds(touch), { landing_page: touch.page_url }), { klaviyo: false, dedupe_seconds: 3600 });
if (touch.source || touch.medium || touch.campaign || touch.content || touch.term) maddoxTrack('utm_parameters_captured', { utm_source:
touch.source, utm_medium: touch.medium, utm_campaign: touch.campaign, utm_content: touch.content, utm_term: touch.term,
landing_page: touch.page_url }, { klaviyo: false, dedupe_seconds: 3600 });
maddoxTrack('channel_group_assigned', { source: touch.source, medium: touch.medium, campaign: touch.campaign, channel_group:
touch.channel_group, sub_channel: touch.sub_channel, ai_referrer: touch.ai_referrer, referral_partner: touch.referral_partner,
offline_sub_source: touch.offline_sub_source }, { klaviyo: false, dedupe_seconds: 3600 });
}
function activeAttributionTouch() {
var current = currentTouch();
if (hasMeaningfulAttribution(current)) return current;
var sessionLatest = readJson(sessionStorage, STORAGE.sessionTouch, null);
var durableLatest = readJson(localStorage, STORAGE.latestMeaningfulTouch, null);
return preferMeaningfulTouch(sessionLatest, durableLatest) || readJson(localStorage, STORAGE.firstTouch, null) || readJson(localStorage,
STORAGE.firstSeen, null) || current;
}
function getAttributionBundle() {
var current = currentTouch();
var firstSeen = readJson(localStorage, STORAGE.firstSeen, null) || current;
var firstTouch = readJson(localStorage, STORAGE.firstTouch, null) || firstSeen;
var sessionLatest = readJson(sessionStorage, STORAGE.sessionTouch, null);
var durableLatest = readJson(localStorage, STORAGE.latestMeaningfulTouch, null);
var latest = preferMeaningfulTouch(sessionLatest, durableLatest) || firstTouch || current;
var leadCreate = activeAttributionTouch();
return Object.assign(

{},
prefixAttribution('first_seen', firstSeen),
prefixAttribution('first_touch', firstTouch),
prefixAttribution('latest_touch', latest),
{
// Strip the 'direct' sentinel from utm fields — real direct traffic
// should produce absent utm fields in Klaviyo, not the literal string 'direct'
utm_source: (latest.source === 'direct' && latest.medium === 'direct') ? '' : (latest.source || ''),
utm_medium: (latest.source === 'direct' && latest.medium === 'direct') ? '' : (latest.medium || ''),
utm_campaign: latest.campaign || '',
utm_content: latest.content || '',
utm_term: latest.term || '',
lead_create_source: (leadCreate.source === 'direct' && !leadCreate.campaign) ? '' : (leadCreate.source || ''),
lead_create_medium: (leadCreate.medium === 'direct' && !leadCreate.campaign) ? '' : (leadCreate.medium || ''),
lead_create_campaign: leadCreate.campaign || '',
lead_create_content: leadCreate.content || '',
lead_create_term: leadCreate.term || '',
lead_create_landing_page: getSession().landing_page || leadCreate.page_url || '',
lead_create_page: window.location.href,
lead_create_timestamp: nowIso(),
channel_group: leadCreate.channel_group || 'Direct Traffic',
sub_channel: leadCreate.sub_channel || '',
ai_referrer: leadCreate.ai_referrer || '',
// referral_partner should be blank for direct/unknown traffic — never 'direct'
referral_partner: (leadCreate.referral_partner && leadCreate.referral_partner !== 'direct') ? leadCreate.referral_partner : '',
offline_sub_source: leadCreate.offline_sub_source || ''
},
clickIds(firstSeen),
clickIds(firstTouch),
clickIds(latest),
clickIds(leadCreate)
);
}
function prefixAttribution(prefix, attr) {
attr = attr || {};
var out = {};
out[prefix + '_source'] = attr.source || '';
out[prefix + '_medium'] = attr.medium || '';
out[prefix + '_campaign'] = attr.campaign || '';
out[prefix + '_content'] = attr.content || '';
out[prefix + '_term'] = attr.term || '';
out[prefix + '_landing_page'] = attr.page_url || '';
out[prefix + '_referrer'] = attr.referrer || '';
out[prefix + '_timestamp'] = attr.timestamp || '';
return out;
}
function clickIds(attr) {
attr = attr || {};
return {
gclid: attr.gclid || '',
gbraid: attr.gbraid || '',
wbraid: attr.wbraid || '',
fbclid: attr.fbclid || '',
msclkid: attr.msclkid || '',
ttclid: attr.ttclid || '',
linkedin_click_id: attr.linkedin_click_id || ''
};
}
function getConsentSnapshot() {
var marketing = null;
var analytics = null;
var preferences = null;
var source = 'unknown';
try {
if (window.Shopify && window.Shopify.customerPrivacy) {
var cp = window.Shopify.customerPrivacy;
marketing = typeof cp.marketingAllowed === 'function' ? cp.marketingAllowed() : null;
analytics = typeof cp.analyticsProcessingAllowed === 'function' ? cp.analyticsProcessingAllowed() : null;
preferences = typeof cp.preferencesProcessingAllowed === 'function' ? cp.preferencesProcessingAllowed() : null;
source = 'shopify_customer_privacy';
}
} catch (e) {}
try {
var dl = window.dataLayer || [];
for (var i = dl.length - 1; i >= 0; i -= 1) {
var item = dl[i];
var c = item && (item.consent || item['gtm.consentState'] || item);
if (c && (c.analytics_storage || c.ad_storage || c.functionality_storage)) {
marketing = c.ad_storage === 'granted' || c.ad_user_data === 'granted' || c.ad_personalization === 'granted';
analytics = c.analytics_storage === 'granted';

preferences = c.functionality_storage === 'granted';
source = 'google_consent_mode';
break;
}
}
} catch (e) {}
var klaOff = document.cookie.indexOf('__kla_off=true') > -1;
if (klaOff) marketing = false;
var known = marketing !== null || analytics !== null || preferences !== null || klaOff;
return {
consent_state: known ? ((marketing || analytics || preferences) && !klaOff ? 'granted_or_partial' : 'denied') : 'unknown',
marketing_consent: marketing === true,
analytics_consent: analytics === true,
preferences_consent: preferences === true,
consent_source: source,
consent_timestamp: nowIso(),
klaviyo_tracking_allowed: !klaOff && (marketing === true || analytics === true || known === false)
};
}
function basePayload(extra) {
var session = getSession();
var consent = getConsentSnapshot();
return Object.assign({
event_version: VERSION,
anonymous_id: getAnonymousId(),
session_id: session.session_id,
page_url: window.location.href,
page_path: getPath(),
page_title: document.title || PAGE.page_title || '',
page_type: PAGE.page_type || '',
template_type: PAGE.template_type || '',
entity_type: PAGE.entity_type || '',
entity_id: PAGE.entity_id || '',
entity_name: PAGE.entity_name || '',
entity_url: PAGE.entity_url || PAGE.canonical_url || window.location.href,
device_type: getDeviceType(),
browser: getBrowser(),
viewport_width: window.innerWidth || 0,
viewport_height: window.innerHeight || 0,
language: navigator.language || '',
timezone: Intl && Intl.DateTimeFormat ? Intl.DateTimeFormat().resolvedOptions().timeZone || '' : '',
pages_viewed_this_session: session.page_count || 1
}, getAttributionBundle(), consent, pageEntityPayload(), extra || {});
}
function fallbackArticleFunnelStage() {
if (PAGE.article_funnel_stage) return PAGE.article_funnel_stage;
var h = String([PAGE.article_title, PAGE.article_all_tags, PAGE.blog_title, PAGE.article_url].join(' ')).toLowerCase();
if (/invest|investment|advisory|market|collecting|collector|buying|blue.chip|portfolio/.test(h)) return 'commercial_consideration';
if (/artist|exhibition|guide|how.to|what.is|history|biography/.test(h)) return 'education';
return '';
}
function fallbackArticleCommercialIntent() {
if (PAGE.article_commercial_intent) return PAGE.article_commercial_intent;
// Only infer on actual article pages — on product/artist/homepage pages
// article context is blank so this would return a misleading default.
// Return '' (stripped by trimPayload) when there's no article context.
if (!PAGE.article_title && !PAGE.article_all_tags && !PAGE.article_id) return '';
var h = String([PAGE.article_title, PAGE.article_all_tags, PAGE.blog_title, PAGE.article_url].join(' ')).toLowerCase();
if (/invest|investment|advisory|market|collecting|collector|buying|blue.chip|portfolio/.test(h)) return 'high';
if (/artist|exhibition|guide|how.to|what.is|history|biography/.test(h)) return 'medium';
return 'low';
}
function controlledArticleTags() {
var allowed = CONFIG.controlledArticleTags || CONFIG.articleControlledTags || [];
var aliases = CONFIG.articleTagAliases || {};
var fields = [PAGE.article_primary_tag || '', PAGE.article_secondary_tag || '', PAGE.article_third_tag || ''];
if ((!fields[0] && !fields[1] && !fields[2]) && PAGE.article_all_tags && allowed.length) fields = String(PAGE.article_all_tags).split(',');
var out = [];
fields.forEach(function (tag) {
var clean = text(tag, 200);
if (!clean) return;
var mapped = aliases[clean] || aliases[clean.toLowerCase()] || clean;
if (allowed.length && allowed.indexOf(mapped) === -1) return;
if (out.indexOf(mapped) === -1) out.push(mapped);
});
return { primary: out[0] || '', secondary: out[1] || '', third: out[2] || '' };
}
function pageEntityPayload() {

return {
artist_id: PAGE.artist_id || '',
artist_name: PAGE.artist_name || '',
artist_slug: PAGE.artist_slug || '',
artist_page_url: PAGE.artist_page_url || '',
artist_page_url_source: PAGE.artist_page_url_source || '',
artist_category: PAGE.artist_category || '',
artist_born: PAGE.artist_born || '',
artist_based_in_country: PAGE.artist_based_in_country || '',
artist_nationality: PAGE.artist_nationality || '',
artist_report_title: PAGE.artist_report_title || '',
artist_report_url: PAGE.artist_report_url || '',
artwork_id: PAGE.artwork_id || '',
artwork_title: PAGE.artwork_title || '',
shopify_product_id: PAGE.shopify_product_id || '',
shopify_variant_id: selectedVariantId() || PAGE.shopify_variant_id || '',
product_url: PAGE.product_url || '',
current_journey_url: PAGE.current_journey_url || window.location.href,
journey_collection_url: PAGE.journey_collection_url || (/\/collections\//.test(window.location.pathname) ? window.location.href : ''),
price: PAGE.price || '',
price_visibility: PAGE.price_visibility || '',
price_band: PAGE.price_band || '',
availability: PAGE.availability || '',
edition_or_series: PAGE.edition_or_series || '',
medium: PAGE.medium || '',
year: PAGE.year || '',
dimensions: PAGE.dimensions || '',
collection_id: PAGE.collection_id || '',
collection_name: PAGE.collection_name || '',
collection_type: PAGE.collection_type || '',
exhibition_id: PAGE.exhibition_id || '',
exhibition_name: PAGE.exhibition_name || '',
exhibition_url: PAGE.exhibition_url || '',
exhibition_status: PAGE.exhibition_status || '',
exhibition_location: PAGE.exhibition_location || '',
exhibition_start_date: PAGE.exhibition_start_date || '',
exhibition_end_date: PAGE.exhibition_end_date || '',
article_id: PAGE.article_id || '',
article_title: PAGE.article_title || '',
article_url: PAGE.article_url || '',
article_primary_tag: controlledArticleTags().primary,
article_secondary_tag: controlledArticleTags().secondary,
article_third_tag: controlledArticleTags().third,
article_funnel_stage: fallbackArticleFunnelStage(),
article_commercial_intent: fallbackArticleCommercialIntent(),
article_published_date: PAGE.article_published_date || '',
blog_id: PAGE.blog_id || '',
blog_title: PAGE.blog_title || '',
blog_handle: PAGE.blog_handle || '',
document_id: PAGE.document_id || '',
document_title: PAGE.document_title || '',
document_type: PAGE.document_type || '',
document_topic: PAGE.document_topic || '',
document_category: PAGE.document_category || '',
document_url: PAGE.document_url || '',
advisory_topic: PAGE.advisory_topic || '',
investment_interest: PAGE.investment_interest || '',
page_category: PAGE.page_category || '',
journey_type: PAGE.journey_type || ''
};
}
function selectedVariantId() {
var field = document.querySelector('[name="id"], [data-selected-variant-id], [data-variant-id]');
if (!field) return '';
return field.value || field.getAttribute('data-selected-variant-id') || field.getAttribute('data-variant-id') || '';
}
function shouldSendToKlaviyo(eventName, payload, options) {
if (options && options.klaviyo === false) return false;
if (CONFIG.trackKlaviyo === false) return false;
if (!APPROVED_KLAVIYO_EVENTS[eventName]) return false;
var consent = payload || getConsentSnapshot();
if (CONFIG.respectConsent === false) return true;
if (/submitted|requested|created|identified|booked|clicked|viewed|started|error/.test(eventName) && (payload.email || payload.phone ||
payload.commercial_lead === true || payload.lead_type)) return true;
if (consent.consent_state === 'unknown') return false;
return consent.klaviyo_tracking_allowed === true;
}
function dedupeKey(eventName, payload) {
if (payload && payload.dedupe_key) return payload.dedupe_key;
if (payload && payload.submission_id) return eventName + '|submission|' + payload.submission_id;

if (payload && payload.booking_id) return eventName + '|booking|' + payload.booking_id;
if (payload && (payload.document_id || payload.document_url)) return eventName + '|document|' + (payload.document_id ||
payload.document_url) + '|' + getSession().session_id;
if (payload && (payload.article_id || payload.page_path)) return eventName + '|page|' + (payload.article_id || payload.entity_id ||
payload.page_path || getPath()) + '|' + getSession().session_id;
return eventName + '|' + getSession().session_id + '|' + (payload && (payload.link_url || payload.form_id || payload.entity_id) || getPath());
}
function isDuplicate(eventName, payload, seconds) {
seconds = seconds || 0;
if (!seconds) return false;
var key = dedupeKey(eventName, payload || {});
var now = Date.now();
if (eventDedupe[key] && now - eventDedupe[key] < seconds * 1000) return true;
eventDedupe[key] = now;
writeJson(localStorage, STORAGE.eventDedupe, eventDedupe);
return false;
}
function trimPayload(payload) {
var out = {};
Object.keys(payload || {}).forEach(function (key) {
var value = payload[key];
if (value === undefined || value === null || value === '') return;
if (typeof value === 'string') out[key] = value.slice(0, key === 'message' ? 8000 : 1000);
else out[key] = value;
});
return out;
}
var BROWSER_SUPPRESSED_EVENTS = { lead_created: true, sales_intent_lead_created: true };
function maddoxTrack(eventName, properties, options) {
eventName = text(eventName, 120);
if (!eventName) return null;
if (BROWSER_SUPPRESSED_EVENTS[eventName]) {
var suppressed = Object.assign({ event_name: eventName, occurred_at: nowIso(),
routing_status: 'suppressed', suppression_reason: 'authoritative_server_event_only',
send_to_klaviyo: false, send_to_dataLayer: false, klaviyo_delivery_status: 'not_sent' }, properties || {});
window.MADDOX_SUPPRESSED_TRACKING_EVENTS = window.MADDOX_SUPPRESSED_TRACKING_EVENTS || [];
window.MADDOX_SUPPRESSED_TRACKING_EVENTS.push(suppressed);
if (window.MADDOX_SUPPRESSED_TRACKING_EVENTS.length > 50)
window.MADDOX_SUPPRESSED_TRACKING_EVENTS = window.MADDOX_SUPPRESSED_TRACKING_EVENTS.slice(-50);
try { window.dispatchEvent(new CustomEvent('maddox:suppressed', { detail: suppressed })); } catch (e) {}
log('suppressed (authoritative_server_event_only)', eventName);
return null;
}
options = options || {};
var base = basePayload(Object.assign({
event_name: eventName,
event_id: uuid('evt'),
occurred_at: nowIso()
}, properties || {}));
var sendToKlaviyo = shouldSendToKlaviyo(eventName, base, options);
var sendToDataLayer = options.dataLayer !== false && CONFIG.pushDataLayer !== false;
base.routing_status = sendToKlaviyo && sendToDataLayer ? 'klaviyo_and_dataLayer'
: sendToKlaviyo ? 'klaviyo' : sendToDataLayer ? 'dataLayer_only' : 'local_only';
base.send_to_klaviyo = sendToKlaviyo;
base.send_to_dataLayer = sendToDataLayer;
base.klaviyo_delivery_status = sendToKlaviyo ? 'queued' : 'not_sent';
base.suppression_reason = '';
var payload = trimPayload(base);
if (isDuplicate(eventName, payload, options.dedupe_seconds !== undefined ? options.dedupe_seconds : 0)) return null;
window.MADDOX_TRACKING_EVENTS = window.MADDOX_TRACKING_EVENTS || [];
window.MADDOX_TRACKING_EVENTS.push(payload);
if (window.MADDOX_TRACKING_EVENTS.length > 100) window.MADDOX_TRACKING_EVENTS =
window.MADDOX_TRACKING_EVENTS.slice(-100);
if (sendToDataLayer) {
window.dataLayer = window.dataLayer || [];
window.dataLayer.push(Object.assign({ event: eventName }, payload));
}
try {
window.dispatchEvent(new CustomEvent('maddox:track', { detail: payload }));
} catch (e) {}
if (sendToKlaviyo) klaviyoTrack(eventName, payload, 4);
log('tracked', eventName, payload);
return payload;
}
function klaviyoTrack(eventName, payload, attempts) {
if (!eventName || !payload) return;
var props = Object.assign({}, payload);
delete props.event_name;

delete props.routing_status;
delete props.send_to_klaviyo;
delete props.send_to_dataLayer;
delete props.klaviyo_delivery_status;
delete props.suppression_reason;
delete props.event_destination;
if (window.klaviyo && typeof window.klaviyo.track === 'function') {
try { window.klaviyo.track(eventName, props); return; } catch (e) {}
}
if (window._learnq && typeof window._learnq.push === 'function') {
try { window._learnq.push(['track', eventName, props]); return; } catch (e) {}
}
if (attempts > 0) window.setTimeout(function () { klaviyoTrack(eventName, payload, attempts - 1); }, 300);
}
function klaviyoIdentify(payload, attempts) {
if (!payload || !payload.email) return;
var props = trimPayload({
email: payload.email,
first_name: payload.first_name || '',
last_name: payload.last_name || '',
phone_number: payload.phone || '',
anonymous_id: payload.anonymous_id || getAnonymousId(),
latest_lead_type: payload.lead_type || '',
latest_form_name: payload.form_name || '',
latest_artist_interest: payload.artist_name || '',
latest_artwork_interest: payload.artwork_title || '',
latest_document_interest: payload.document_title || '',
latest_article_primary_tag: payload.article_primary_tag || '',
latest_channel_group: payload.channel_group || '',
latest_touch_source: payload.latest_touch_source || '',
latest_touch_medium: payload.latest_touch_medium || '',
latest_touch_campaign: payload.latest_touch_campaign || ''
});
if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
try { window.klaviyo.identify(props); return; } catch (e) {}
}
if (window._learnq && typeof window._learnq.push === 'function') {
try { window._learnq.push(['identify', props]); return; } catch (e) {}
}
if (attempts > 0) window.setTimeout(function () { klaviyoIdentify(payload, attempts - 1); }, 300);
}
function detectKlaviyoFormId(form, detail) {
var ids = Object.keys(FORM_ID_MAPPINGS || {});
function knownId(value) {
value = String(value || '');
for (var i = 0; i < ids.length; i += 1) if (value === ids[i] || value.indexOf(ids[i]) > -1) return ids[i];
return '';
}
function strictClass(value) {
var m = String(value || '').match(/\bklaviyo-form-([A-Za-z0-9]{4,8})\b/);
return m ? m[1] : '';
}
if (detail) {
var direct = detail.formId || detail.form_id || detail.id || detail.form || '';
if (direct && typeof direct === 'object') direct = direct.id || direct.formId || direct.form_id || '';
var detailStr = [direct, detail.formVersionId, detail.form_version_id, detail.formName, detail.form_name].filter(Boolean).join(' ');
var kid = knownId(detailStr); if (kid) return kid;
var sid = strictClass(detailStr); if (sid && FORM_ID_MAPPINGS[sid]) return sid;
}
var node = form || null, hops = 0;
while (node && hops < 8) {
var parts = [];
try {
parts.push(node.getAttribute && node.getAttribute('data-form-id') || '');
parts.push(node.getAttribute && node.getAttribute('data-klaviyo-form-id') || '');
parts.push(node.getAttribute && node.getAttribute('data-testid') || '');
parts.push(node.id || '');
parts.push(node.className || '');
} catch (e) {}
var all = parts.filter(Boolean).join(' ');
var k = knownId(all); if (k) return k;
var s = strictClass(all); if (s && FORM_ID_MAPPINGS[s]) return s;
node = node.parentElement || null;
hops += 1;
}
return '';
}
function formMapping(form, detail) {
var id = detectKlaviyoFormId(form, detail);
var mapped = id && FORM_ID_MAPPINGS[id] ? FORM_ID_MAPPINGS[id] : null;

if (mapped) return Object.assign({ form_id: id }, mapped);
var intent = form && form.dataset && (form.dataset.formIntent || form.dataset.leadType) || inferFormIntent(form);
return { form_id: id || form && (form.dataset.formId || form.id) || '', form_intent: intent, form_name: form && (form.dataset.formName ||
form.getAttribute('aria-label') || form.id) || 'Website Form', event_name: eventForIntent(intent), lead_type: leadTypeForIntent(intent),
commercial_lead: commercialLeadForIntent(intent) };
}
function inferFormIntent(form) {
var haystack = text([form && form.id, form && form.className, form && form.getAttribute('action'), form && form.textContent,
PAGE.page_category, PAGE.entity_type].join(' '), 3000).toLowerCase();
if (/newsletter|subscribe|mailing list/.test(haystack)) return 'newsletter_signup';
if (/sell|consign|valuation|owned art|provenance|certificate/.test(haystack)) return 'consignment';
if (/advisory|advisor|consultation|investment/.test(haystack)) return 'advisory';
if (/document|download|pdf|guide|report/.test(haystack)) return 'document_request';
if (/exhibition|rsvp|private view/.test(haystack)) return 'exhibition_enquiry';
if (/artwork|piece|work|viewing|product/.test(haystack) || PAGE.entity_type === 'artwork') return 'artwork_enquiry';
if (/artist|portfolio|submission/.test(haystack) || PAGE.entity_type === 'artist') return 'artist_enquiry';
return 'general_enquiry';
}
function eventForIntent(intent) {
var map = {
newsletter_signup: 'soft_lead_created',
consignment: 'consignment_enquiry_submitted',
advisory: 'advisory_form_submitted',
document_request: 'document_requested',
exhibition_enquiry: 'exhibition_enquiry_submitted',
artwork_enquiry: 'artwork_enquiry_submitted',
artist_enquiry: 'artist_enquiry_submitted',
artist_submission: 'artist_submission_received',
general_enquiry: 'lead_form_submitted'
};
return map[intent] || 'lead_form_submitted';
}
function leadTypeForIntent(intent) {
var map = {
newsletter_signup: 'newsletter',
consignment: 'sell_your_art',
advisory: 'advisory',
document_request: 'document',
exhibition_enquiry: 'exhibition',
artwork_enquiry: 'artwork',
artist_enquiry: 'artist',
artist_submission: 'artist_submission',
general_enquiry: 'contact'
};
return map[intent] || 'contact';
}
function commercialLeadForIntent(intent) {
return ['newsletter_signup', 'artist_submission'].indexOf(intent) === -1;
}
function isLeadForm(form) {
if (!form || form.getAttribute('data-maddox-ignore') === 'true') return false;
var action = form.getAttribute('action') || '';
if (/\/cart|\/search|\/account|\/checkout|\/password|\/login/i.test(action)) return false;
var mapping = formMapping(form);
if (mapping && mapping.form_intent) return true;
return !!form.querySelector('input[type="email"], input[name*="email" i]');
}
function isKlaviyoForm(form) {
if (!form) return false;
var haystack = text([form.id, form.className, form.getAttribute && form.getAttribute('data-form-id'), form.getAttribute &&
form.getAttribute('data-testid'), form.closest && form.closest('[class*="klaviyo"], .klaviyo-form') && 'klaviyo'].join(' '), 1000).toLowerCase();
return /klaviyo|needsclick|kl-private/.test(haystack);
}
function formVersionId(detail, form) {
detail = detail || {};
return text(detail.formVersionId || detail.form_version_id || detail.versionId || detail.version_id || (form && form.getAttribute &&
(form.getAttribute('data-form-version-id') || form.getAttribute('data-version-id'))) || '', 120);
}
function formStateKey(form, detail) {
var mapping = formMapping(form, detail || null);
var formId = mapping.form_id || detectKlaviyoFormId(form, detail) || 'unknown_form';
var version = formVersionId(detail, form);
return [formId, version, getPath(), getSession().session_id].join('|');
}

function readFormStates() {
var states = readJson(sessionStorage, STORAGE.formState, {});
var now = Date.now();
Object.keys(states || {}).forEach(function (key) {
if (!states[key] || !states[key].updated_at_ms || now - states[key].updated_at_ms > FORM_STATE_TTL_MS) delete states[key];
});
return states || {};
}
function writeFormStates(states) {
writeJson(sessionStorage, STORAGE.formState, states || {});
}
function mergeObjects(target, source) {
target = target || {};
source = source || {};
Object.keys(source).forEach(function (key) {
var value = source[key];
if (value === undefined || value === null || value === '') return;
target[key] = value;
});
return target;
}
function inferStep(form, detail) {
detail = detail || {};
var candidates = [detail.step, detail.stepNumber, detail.currentStep, detail.formStep, detail.page, detail.screen].filter(function (v) { return v
!== undefined && v !== null && v !== ''; });
if (candidates.length) return parseInt(candidates[0], 10) || 1;
var el = form && form.querySelector && form.querySelector('[data-step], [data-current-step], [aria-current="step"]');
var raw = el && (el.getAttribute('data-step') || el.getAttribute('data-current-step') || el.textContent || '');
var match = String(raw || '').match(/(\d+)/);
return match ? parseInt(match[1], 10) || 1 : 1;
}
function inferTotalSteps(form, detail) {
detail = detail || {};
var candidates = [detail.totalSteps, detail.total_steps, detail.steps, detail.stepCount].filter(function (v) { return v !== undefined && v !== null
&& v !== ''; });
if (candidates.length) return parseInt(candidates[0], 10) || 0;
var count = 0;
try { count = form && form.querySelectorAll ? form.querySelectorAll('[data-step], [data-step-index], [aria-current="step"]').length : 0; } catch
(e) {}
return count || 0;
}
function collectVisibleFormData(form, detail) {
var mapping = formMapping(form, detail);
var map = FORM_FIELD_MAPPINGS[mapping.form_id] || {};
var fields = {};
if (form && form.querySelectorAll) {
Array.prototype.forEach.call(form.querySelectorAll('input, textarea, select'), function (field) {
if (!field || isSensitiveField(field) || field.getAttribute('data-maddox-auto-field') === 'true') return;
var raw = field.name || field.id || field.getAttribute('aria-label') || field.getAttribute('placeholder') || '';
var label = findLabel(form, field);
var value = readFieldValue(field);
if (value === undefined || value === null || value === '') return;
var canonical = map[raw] || map[label] || normaliseFieldName(raw || label);
if (!canonical) return;
fields[canonical] = text(value, canonical === 'message' ? 8000 : 1000);
});
}
if (detail && typeof detail === 'object') {
var buckets = [detail.formData, detail.form_data, detail.data, detail.properties, detail.metaData, detail.metadata, detail.profileProperties];
buckets.forEach(function (bucket) {
if (!bucket || typeof bucket !== 'object') return;
Object.keys(bucket).forEach(function (key) {
var canonical = map[key] || normaliseFieldName(key);
if (canonical) fields[canonical] = text(bucket[key], canonical === 'message' ? 8000 : 1000);
});
});
}
return fields;
}
function updateFormState(form, detail, source) {
if (!form && !detail) return null;
var states = readFormStates();
var key = formStateKey(form, detail || null);
var mapping = formMapping(form, detail || null);
var existing = states[key] || {};
var fields = collectVisibleFormData(form, detail);
var step = inferStep(form, detail);

var totalSteps = inferTotalSteps(form, detail);
var startedAt = existing.started_at || nowIso();
var startedAtMs = existing.started_at_ms || Date.now();
var furthest = Math.max(existing.furthest_step || 0, step || 1);
var completion = totalSteps ? Math.min(100, Math.round((furthest / totalSteps) * 100)) : Math.max(existing.completion_percent || 0,
countFilledFields(fields) ? 50 : 0);
states[key] = Object.assign({}, existing, {
state_key: key,
form_id: mapping.form_id || existing.form_id || '',
form_name: mapping.form_name || existing.form_name || '',
form_intent: mapping.form_intent || existing.form_intent || '',
lead_type: mapping.lead_type || existing.lead_type || '',
commercial_lead: mapping.commercial_lead === true || existing.commercial_lead === true,
form_version_id: formVersionId(detail, form) || existing.form_version_id || '',
fields: mergeObjects(existing.fields || {}, fields),
email: fields.email || existing.email || '',
phone: fields.phone || existing.phone || '',
first_step_seen: existing.first_step_seen || step || 1,
furthest_step: furthest,
total_steps: totalSteps || existing.total_steps || '',
completion_percent: completion,
last_completed_field: lastFieldName(fields) || existing.last_completed_field || '',
started_at: startedAt,
started_at_ms: startedAtMs,
updated_at: nowIso(),
updated_at_ms: Date.now(),
source_signal: source || existing.source_signal || 'dom'
});
writeFormStates(states);
return states[key];
}
function countFilledFields(obj) {
var count = 0;
Object.keys(obj || {}).forEach(function (key) { if (obj[key] !== undefined && obj[key] !== null && obj[key] !== '') count += 1; });
return count;
}
function lastFieldName(obj) {
var keys = Object.keys(obj || {}).filter(function (key) { return obj[key] !== undefined && obj[key] !== null && obj[key] !== ''; });
return keys.length ? keys[keys.length - 1] : '';
}
function storedFormState(form, detail) {
var states = readFormStates();
return states[formStateKey(form, detail || null)] || null;
}
function markFormStateSubmitted(form, detail, payload) {
var states = readFormStates();
var targetKey = '';
try { targetKey = formStateKey(form, detail || null); } catch (e) {}
Object.keys(states || {}).forEach(function (key) {
var state = states[key];
if (!state) return;
var sameKey = targetKey && key === targetKey;
var sameForm = payload && payload.form_id && state.form_id === payload.form_id &&
(!payload.form_version_id || !state.form_version_id || state.form_version_id === payload.form_version_id);
if (sameKey || sameForm) {
state.submitted = true;
state.submitted_at = nowIso();
state.submission_id = (payload && payload.submission_id) || state.submission_id || '';
state.updated_at = nowIso();
state.updated_at_ms = Date.now();
states[key] = state;
}
});
writeFormStates(states);
}
function clearFormState(form, detail) {
var states = readFormStates();
delete states[formStateKey(form, detail || null)];
writeFormStates(states);
}
function collectFormData(form, detail) {
var visible = collectVisibleFormData(form, detail);
var state = updateFormState(form, detail, detail ? 'detail' : 'dom') || {};
var fields = mergeObjects({}, state.fields || {});
fields = mergeObjects(fields, visible);
var explicitMarketing = fields.marketing_consent || queryFormField(form, ['marketing_consent', 'marketingConsent', 'accepts_marketing']);
var explicitProcess = fields.process_consent || queryFormField(form, ['process_consent', 'processConsent', 'processing_consent']);

return Object.assign({}, fields, {
email: text(fields.email || queryFormField(form, ['email', 'Email', '$email']), 300).toLowerCase(),
first_name: text(fields.first_name || queryFormField(form, ['first_name', 'firstName', 'firstname', 'FirstName']), 300),
last_name: text(fields.last_name || queryFormField(form, ['last_name', 'lastName', 'lastname', 'LastName']), 300),
phone: text(fields.phone || queryFormField(form, ['phone', 'Phone', 'phone_number']), 300),
message: text(fields.message || queryFormField(form, ['message', 'Message']), 8000),
marketing_consent: bool(explicitMarketing, false),
process_consent: bool(explicitProcess, false),
self_reported_source: text(fields.self_reported_source || queryFormField(form, ['self_reported_source', 'How did you hear about us?',
'how_did_you_hear_about_us']), 500),
form_version_id: state.form_version_id || formVersionId(detail, form) || '',
furthest_step: state.furthest_step || '',
total_steps: state.total_steps || '',
completion_percent: state.completion_percent || '',
last_completed_field: state.last_completed_field || ''
});
}
function buildFormPayload(form, detail, refreshSubmission) {
var mapping = formMapping(form, detail);
var data = collectFormData(form, detail);
var eventName = mapping.event_name || eventForIntent(mapping.form_intent);
// Enrich document payload when form is WYLkqu on a non-document page
// (e.g. artist collection page, product page) — pull available page context
if (mapping.form_id === 'WYLkqu' || mapping.form_intent === 'document_request') {
if (!data.document_title) data.document_title = PAGE.document_title || PAGE.artist_report_title || '';
if (!data.document_url) data.document_url = PAGE.document_url || PAGE.artist_report_url || window.location.href;
if (!data.document_type) data.document_type = PAGE.document_type || '';
if (!data.document_topic) data.document_topic = PAGE.document_topic || '';
if (!data.document_category) data.document_category = PAGE.document_category || '';
}
if (eventName === 'document_requested' && isInvestmentDocument(data)) eventName = 'investment_document_requested';
var submissionId = refreshSubmission || !form || !form.getAttribute ? uuid('sub') : form.getAttribute('data-maddox-submission-id') ||
uuid('sub');
if (form && form.setAttribute) form.setAttribute('data-maddox-submission-id', submissionId);
return basePayload(Object.assign({}, data, {
event_name: eventName,
submission_id: submissionId,
form_id: mapping.form_id || '',
form_version_id: data.form_version_id || formVersionId(detail, form) || '',
form_name: mapping.form_name || '',
form_intent: mapping.form_intent || '',
form_type: mapping.lead_type || leadTypeForIntent(mapping.form_intent),
form_location: formLocation(form),
lead_type: mapping.lead_type || leadTypeForIntent(mapping.form_intent),
commercial_lead: mapping.commercial_lead === true,
signup_source: data.signup_source || mapping.form_name || '',
dedupe_key: formSubmitDedupeKey(eventName, mapping, data, submissionId),
consent_source: mapping.form_name || data.consent_source || 'Website Form',
consent_timestamp: nowIso()
}));
}
function formSubmitDedupeKey(eventName, mapping, data, submissionId) {
var variant = data.shopify_variant_id || selectedVariantId() || PAGE.shopify_variant_id || '';
var dimensions = data.dimensions || PAGE.dimensions || '';
var artworkId = data.artwork_id || PAGE.artwork_id || '';
var email = data.email || '';
if (!email && !artworkId && submissionId) return [eventName, 'submission', submissionId].join('|');
return [eventName, mapping && mapping.form_id || '', data.form_version_id || '', email, getPath(), artworkId, variant, dimensions].join('|');
}
function isInvestmentDocument(data) {
var haystack = text([
PAGE.document_title, PAGE.document_type, PAGE.document_topic, PAGE.document_category,
PAGE.artist_report_title,
data.document_title, data.document_topic
].join(' '), 1000).toLowerCase();
return /invest|investment|market report|why invest|advisory|guide|report/.test(haystack);
}
function formLocation(form) {
if (!form || !form.closest) return '';
var popup = form.closest('[role="dialog"], [aria-modal="true"], .modal, [class*="modal"], .popup, [class*="popup"], [class*="drawer"]');
if (popup) return 'popup_or_modal';
var section = form.closest('section, [data-section-id], main, article');
return section ? text(section.id || section.getAttribute('data-section-id') || section.className || 'inline', 200) : 'inline';
}
function setHidden(form, name, value) {
if (!form || !name || value === undefined || value === null) return;
var existing = null;
try { existing = form.querySelector('[name="' + name + '"]'); } catch (e) {}

if (!existing) {
existing = document.createElement('input');
existing.type = 'hidden';
existing.name = name;
existing.setAttribute('data-maddox-auto-field', 'true');
form.appendChild(existing);
}
existing.value = typeof value === 'object' ? JSON.stringify(value) : String(value);
}
function hydrateForm(form) {
if (!isLeadForm(form)) return;
var payload = buildFormPayload(form, null, false);
HIDDEN_FIELDS.forEach(function (field) {
if (payload[field] !== undefined && payload[field] !== null && payload[field] !== '') setHidden(form, field, payload[field]);
});
form.setAttribute('data-maddox-hydrated', 'true');
}
function hydrateAllForms(root) {
var scope = root || document;
var forms = scope.querySelectorAll ? scope.querySelectorAll('form') : [];
Array.prototype.forEach.call(forms, hydrateForm);
}
function closestLeadContainer(target) {
if (!target || !target.closest) return null;
var form = target.closest('form');
if (form) return form;
return target.closest('[class*="klaviyo-form-"], .klaviyo-form, [data-testid*="klaviyo"], [class*="needsclick"]');
}
function onFormStarted(event) {
var container = closestLeadContainer(event.target);
if (!container) return;
var form = container.tagName === 'FORM' ? container : container.querySelector('form') || container;
if (!isLeadForm(form)) {
if (container !== form) hydrateAllForms(container);
return;
}
hydrateForm(form);
updateFormState(form, null, 'interaction');
var mapping = formMapping(form);
var key = (mapping.form_id || formLocation(form) || 'form') + '|' + getPath() + '|' + getSession().session_id;
if (startedForms[key]) return;
startedForms[key] = true;
maddoxTrack('lead_form_started', { form_id: mapping.form_id || '', form_name: mapping.form_name || '', form_type: mapping.lead_type || '',
form_location: formLocation(form), lead_type: mapping.lead_type || '', commercial_lead: mapping.commercial_lead === true }, {
dedupe_seconds: 3600 });
}
function onFormInvalid(event) {
var field = event.target;
var form = field && field.closest ? field.closest('form') : null;
if (!form || !isLeadForm(form)) return;
var mapping = formMapping(form);
maddoxTrack('lead_form_error_seen', { form_id: mapping.form_id || '', form_name: mapping.form_name || '', form_type: mapping.lead_type
|| '', lead_type: mapping.lead_type || '', field_name: normaliseFieldName(field.name || field.id || ''), error_type: 'validation', error_message:
text(field.validationMessage || '', 500), commercial_lead: mapping.commercial_lead === true }, { dedupe_seconds: 5 });
}
function onFormSubmit(event) {
var form = event.target;
if (!form || form.tagName !== 'FORM' || !isLeadForm(form)) return;
updateFormState(form, null, 'native_submit');
hydrateForm(form);
if (isKlaviyoForm(form)) return;
var payload = buildFormPayload(form, null, true);
submittedForms[payload.submission_id] = true;
dispatchLeadEvents(payload);
markFormStateSubmitted(form, null, payload);
clearFormState(form, null);
}
function dispatchLeadEvents(payload) {
if (!payload) return;
if (submittedForms[payload.dedupe_key] && Date.now() - submittedForms[payload.dedupe_key] < 10000) return;
submittedForms[payload.dedupe_key] = Date.now();
if (payload.email) identifyKnownUser(payload);
maybeTrackMarketingConsent(payload);
maddoxTrack('lead_create_source_captured', { submission_id: payload.submission_id, lead_type: payload.lead_type, lead_create_source:
payload.lead_create_source, lead_create_medium: payload.lead_create_medium, lead_create_campaign: payload.lead_create_campaign,
lead_create_page: payload.lead_create_page, channel_group: payload.channel_group }, { klaviyo: false, dedupe_seconds: 10 });

trackSourceQualityForLead(payload);
maddoxTrack(payload.event_name, payload, { dedupe_seconds: 10 });
}
function maybeTrackMarketingConsent(payload) {
if (!payload || !payload.email || payload.marketing_consent !== true) return;
var store = readJson(localStorage, STORAGE.consentGranted, {});
var key = payload.email.toLowerCase();
var last = store[key] || 0;
if (last && Date.now() - last < 30 * 24 * 60 * 60 * 1000) return;
store[key] = Date.now();
writeJson(localStorage, STORAGE.consentGranted, store);
maddoxTrack('marketing_consent_granted', { email: payload.email, phone: payload.phone || '', marketing_consent: true, consent_source:
payload.consent_source || payload.form_name || '', consent_timestamp: payload.consent_timestamp || nowIso(), form_name:
payload.form_name || '' }, { dedupe_seconds: 30 * 24 * 60 * 60 });
}
function trackSourceQualityForLead(payload) {
if (!payload) return;
var hasKnownSource = !!(payload.lead_create_source && payload.lead_create_source !== 'direct' || payload.first_touch_source &&
payload.first_touch_source !== 'direct' || payload.referral_partner || payload.gclid || payload.fbclid || payload.msclkid ||
payload.linkedin_click_id);
if (!hasKnownSource) maddoxTrack('source_unknown_detected', { submission_id: payload.submission_id || '', session_id:
payload.session_id || '', page_url: payload.page_url || '', referrer: payload.referrer || '', source: payload.lead_create_source || '', medium:
payload.lead_create_medium || '' }, { klaviyo: false, dedupe_seconds: 3600 });
if (/(paid|email|affiliate)/i.test(String(payload.channel_group || '')) && (!payload.lead_create_source || !payload.lead_create_medium ||
!payload.lead_create_campaign)) maddoxTrack('utm_missing_detected', { submission_id: payload.submission_id || '', page_url:
payload.page_url || '', source: payload.lead_create_source || '', medium: payload.lead_create_medium || '', campaign:
payload.lead_create_campaign || '', missing_fields: ['source', 'medium', 'campaign'].filter(function (field) { return !payload['lead_create_' + field];
}).join(',') }, { klaviyo: false, dedupe_seconds: 3600 });
}
function identifyKnownUser(payload) {
var known = { identified_at: nowIso(), lead_type: payload.lead_type || '', email: payload.email || '', first_seen_at: '' };
var existing = readJson(localStorage, STORAGE.knownProfile, null);
if (existing && existing.first_seen_at) known.first_seen_at = existing.first_seen_at;
else known.first_seen_at = nowIso();
writeJson(localStorage, STORAGE.knownProfile, known);
klaviyoIdentify(payload, 5);
maddoxTrack('identity_identified', { email: payload.email, phone: payload.phone || '', lead_type: payload.lead_type || '', form_name:
payload.form_name || '', recent_artwork_history: recentArtworkHistorySummary() }, { dedupe_seconds: 10 });
}
function handleKlaviyoSignal(detail, source) {
detail = detail || {};
var type = String(detail.type || detail.eventName || detail.event || source || '').toLowerCase();
if (type && !/(submit|success|complete)/.test(type)) return;
var formId = detectKlaviyoFormId(null, detail);
var form = findKlaviyoForm(formId);
if (!form) form = virtualForm(formId, detail);
updateFormState(form, detail, source || 'klaviyo_signal');
var payload = buildFormPayload(form, detail, true);
payload.event_source = source || 'klaviyo_form_signal';
dispatchLeadEvents(payload);
markFormStateSubmitted(form, detail, payload);
clearFormState(form, detail);
}
function findKlaviyoForm(formId) {
if (!formId) return null;
try {
var byClass = document.querySelector('[class*="klaviyo-form-' + formId + '"]');
if (byClass) return byClass.tagName === 'FORM' ? byClass : byClass.querySelector('form') || byClass;
} catch (e) {}
var selectors = [
'form[data-form-id="' + formId + '"]',
'form[data-klaviyo-form-id="' + formId + '"]',
'form[id*="' + formId + '"]',
'[data-testid*="' + formId + '"] form',
'[class*="klaviyo-form-' + formId + '"] form'
];
for (var i = 0; i < selectors.length; i += 1) {
try {
var found = document.querySelector(selectors[i]);
if (found) return found.tagName === 'FORM' ? found : found.querySelector('form') || found;
} catch (e) {}
}
return null;
}
function virtualForm(formId, detail) {
var mapped = FORM_ID_MAPPINGS[formId] || {};
return {

tagName: 'FORM',
id: formId || '',
dataset: { formId: formId || '', formName: mapped.form_name || detail.formName || '', formIntent: mapped.form_intent || '' },
getAttribute: function (name) { if (name === 'data-form-id') return formId || ''; if (name === 'aria-label') return mapped.form_name ||
detail.formName || ''; if (name === 'id') return formId || ''; return ''; },
setAttribute: function () {},
querySelectorAll: function () { return []; },
querySelector: function () { return null; },
appendChild: function () {},
closest: function () { return null; }
};
}
function observeLeadForms() {
if (typeof IntersectionObserver === 'undefined') return;
var observer = new IntersectionObserver(function (entries) {
entries.forEach(function (entry) {
if (!entry.isIntersecting) return;
var form = entry.target;
if (!isLeadForm(form)) return;
var mapping = formMapping(form);
var key = (mapping.form_id || formLocation(form) || 'form') + '|' + getSession().session_id;
if (viewedForms[key]) return;
viewedForms[key] = true;
maddoxTrack('lead_form_viewed', { form_id: mapping.form_id || '', form_name: mapping.form_name || '', form_type: mapping.lead_type ||
'', form_location: formLocation(form), lead_type: mapping.lead_type || '', commercial_lead: mapping.commercial_lead === true }, {
dedupe_seconds: 3600 });
});
}, { threshold: 0.25 });
Array.prototype.forEach.call(document.querySelectorAll('form'), function (form) {
if (isLeadForm(form)) observer.observe(form);
});
window.MADDOX_FORM_VIEW_OBSERVER = observer;
}
function elementText(el) {
if (!el) return '';
return text(el.getAttribute && (el.getAttribute('aria-label') || el.getAttribute('title') || el.getAttribute('data-label')) || el.value || el.textContent || '',
200);
}
function closestArticleRoot(el) {
if (!el || !el.closest) return null;
return el.closest('[data-article-content], article, .article-template, .article-content, .rte');
}
function sourceContext(el) {
var section = el && el.closest && el.closest('[data-section-id], section, main, article, [id]');
return {
cta_location: section ? text(section.getAttribute('data-section-id') || section.id || section.className || '', 200) : '',
source_section: section ? text(section.getAttribute('data-section-id') || section.id || section.className || '', 200) : ''
};
}
function classifyCta(el, href, label) {
var explicit = el && el.dataset && (el.dataset.ctaType || el.dataset.ctaIntent || el.dataset.leadType || el.dataset.formIntent);
var combined = text([explicit, href, label, el && el.className].join(' '), 1000).toLowerCase();
if (/directions|google maps|maps\.app\.goo|maps\.google|map|route/.test(combined)) return { event: 'directions_clicked', cta_type:
'directions', lead_type: 'offline_intent', high: false };
if (/book|appointment|calendar|bookeasy|consultation/.test(combined)) return { event: 'appointment_cta_clicked', cta_type: 'appointment',
lead_type: 'appointment', high: true };
if (/whatsapp|wa\.me/.test(combined)) return { event: 'whatsapp_clicked', cta_type: 'whatsapp', lead_type: 'contact', high: true };
if (/^tel:/i.test(href)) return { event: 'phone_number_clicked', cta_type: 'phone', lead_type: 'contact', high: true };
if (/^mailto:/i.test(href)) return { event: 'email_link_clicked', cta_type: 'email', lead_type: 'contact', high: true };
if
(/enquir|inquir|contact|advisory|sell|consign|valuation|document|download|pdf|guide|report|rsvp|exhibition|artist|artwork|viewing/.test(combined))
return { event: 'high_intent_cta_clicked', cta_type: explicit || 'high_intent', lead_type: explicit || '', high: true };
if (el && (el.hasAttribute('data-maddox-track') || el.hasAttribute('data-track-cta') || el.hasAttribute('data-cta-type'))) return { event:
'cta_clicked', cta_type: explicit || 'cta', lead_type: explicit || '', high: false };
return null;
}
function onClick(event) {
var el = event.target && event.target.closest ? event.target.closest('a, button, [role="button"], input[type="button"], input[type="submit"]') :
null;
if (!el) return;
var href = el.getAttribute('href') || '';
var label = elementText(el);
var articleRoot = closestArticleRoot(el);
if (articleRoot && href) trackArticleLink(el, href, label);
var cta = classifyCta(el, href, label);
if (!cta) return;
var key = [cta.event, href, label, getSession().session_id].join('|');

if (ctaMemory[key] && Date.now() - ctaMemory[key] < 1500) return;
ctaMemory[key] = Date.now();
var payload = Object.assign({ cta_text: label, cta_type: cta.cta_type, cta_destination_url: href, lead_type: cta.lead_type, commercial_lead:
cta.high === true }, sourceContext(el));
var known = readJson(localStorage, STORAGE.knownProfile, null);
var ctaOptions = cta.event === 'directions_clicked' ? { klaviyo: !!(known && known.email), dedupe_seconds: 2 } : { dedupe_seconds: 2 };
maddoxTrack(cta.event, payload, ctaOptions);
// Dedicated named CTA events must NOT also fire high_intent_cta_clicked —
// that creates duplicate Klaviyo events and double-triggers flows.
var DEDICATED_CTA_EVENTS = {
phone_number_clicked: true, email_link_clicked: true, whatsapp_clicked: true,
appointment_cta_clicked: true, directions_clicked: true
};
if (cta.event !== 'high_intent_cta_clicked' && cta.high === true && !DEDICATED_CTA_EVENTS[cta.event]) {
maddoxTrack('high_intent_cta_clicked', payload, { dedupe_seconds: 2 });
}
}
function trackArticleLink(el, href, label) {
if (!PAGE.article_id) return;
var parsed = null;
try { parsed = new URL(href, window.location.href); } catch (e) {}
var destination = parsed ? parsed.pathname : href;
var destinationType = '';
if (/\/products\//.test(destination)) destinationType = 'artwork';
else if (/\/collections\//.test(destination)) destinationType = 'artist_or_collection';
else if (/advisory/.test(destination)) destinationType = 'advisory';
else if (/contact|enquiry|pages/.test(destination)) destinationType = 'lead_page';
var isCta = el.hasAttribute('data-cta-type') || /enquir|contact|book|download|advisory|sell|viewing/i.test(label + ' ' + href);
var payload = Object.assign({ link_text: label, destination_url: href, destination_page_type: destinationType, cta_text: label,
cta_destination_url: href, cta_type: isCta ? 'article_cta' : 'internal_link' }, pageEntityPayload(), sourceContext(el));
maddoxTrack(isCta ? 'article_cta_clicked' : 'article_internal_link_clicked', payload, { dedupe_seconds: 5 });
}
function trackPageIntent() {
var type = PAGE.entity_type || '';
if (type === 'artwork') { maddoxTrack('artwork_viewed', pageEntityPayload(), { dedupe_seconds: 1800 }); trackRepeatArtworkView(); }
else if (type === 'artist') maddoxTrack('artist_page_viewed', pageEntityPayload(), { dedupe_seconds: 1800 });
else if (type === 'exhibition') maddoxTrack('exhibition_page_viewed', pageEntityPayload(), { dedupe_seconds: 1800 });
else if (type === 'advisory') maddoxTrack('advisory_page_viewed', pageEntityPayload(), { dedupe_seconds: 1800 });
else if (type === 'document') maddoxTrack('document_page_viewed', pageEntityPayload(), { dedupe_seconds: 1800 });
else if (type === 'collection') maddoxTrack('collection_viewed', pageEntityPayload(), { dedupe_seconds: 1800 });
else if (type === 'article') {
var articlePayload = pageEntityPayload();
// Inject email when the user is already identified so Klaviyo receives
// article_viewed as an identified track() call (not anonymous).
// Without this, article views never update latest_article_primary_tag
// on the Klaviyo profile, and the events don't appear in DSAR exports.
var knownForArticle = readJson(localStorage, STORAGE.knownProfile, null);
if (knownForArticle && knownForArticle.email) {
articlePayload = Object.assign({}, articlePayload, { email: knownForArticle.email });
// Also update the Klaviyo profile with latest_article_primary_tag
klaviyoIdentify(Object.assign({}, articlePayload, { lead_type: '' }));
}
maddoxTrack('article_viewed', articlePayload, { dedupe_seconds: 1800 });
maddoxTrack('article_tag_viewed', articlePayload, { dedupe_seconds: 1800 });
}
if (type === 'search' && PAGE.search_query) {
maddoxTrack('site_search_performed', { search_term: suppressSensitiveSearch(PAGE.search_query), search_results_count:
PAGE.search_results_count || '' }, { dedupe_seconds: 60 });
}
// gallery_location_viewed must ONLY fire on actual gallery location pages.
// "Maddox Gallery" appears in every page title, so we MUST NOT test document.title.
// Instead test the URL path and template_suffix from PAGE context.
var locationSuffix = String(PAGE.template_suffix || '').toLowerCase();
var locationPath = getPath().toLowerCase();
var isGalleryLocationPage = (
/^location[-/]|^our-location|^locations-/.test(locationSuffix) ||
/\/pages\/(location|our-location|shepherd-market|maddox-street|maddox-dubai|visit|directions)/.test(locationPath)
);
if (isGalleryLocationPage) {
var known = readJson(localStorage, STORAGE.knownProfile, null);
maddoxTrack('gallery_location_viewed', { gallery_location: PAGE.entity_name || PAGE.page_title || '', commercial_lead: false }, { klaviyo: !!
(known && known.email), dedupe_seconds: 1800 });
}
}
function suppressSensitiveSearch(term) {
term = text(term, 200).toLowerCase();
if (/@/.test(term)) return '[suppressed_email_like_search]';
if (/\b\+?\d[\d\s().-]{7,}\b/.test(term)) return '[suppressed_phone_like_search]';
return term;
}

function trackLeadFormAbandonment() {
var states = readFormStates();
var known = readJson(localStorage, STORAGE.knownProfile, null);
Object.keys(states || {}).forEach(function (key) {
var state = states[key];
if (!state || state.submitted === true || state.abandoned === true || !state.started_at_ms) return;
if (Date.now() - state.started_at_ms < 15000) return;
if (state.lead_type === 'newsletter' && !state.email) return;
var hasContact = !!(state.email || state.phone || (known && known.email));
var meaningfulCompletion = (state.completion_percent || 0) >= 50 ||
!!state.last_completed_field || countFilledFields(state.fields || {}) >= 1;
if (!hasContact && !meaningfulCompletion) return;
var payload = {
form_id: state.form_id || '',
form_name: state.form_name || '',
form_type: state.lead_type || '',
form_location: '',
lead_type: state.lead_type || '',
email: state.email || '',
phone: state.phone || '',
completion_percent: state.completion_percent || '',
last_field_completed: state.last_completed_field || '',
commercial_lead: state.commercial_lead === true
};
var sendKlaviyo = !!(payload.email || known && known.email);
maddoxTrack('lead_form_abandoned', payload, { klaviyo: sendKlaviyo, dedupe_seconds: 86400 });
state.abandoned = true;
states[key] = state;
});
writeFormStates(states);
}
function recentArtworkHistorySummary() {
var history = readJson(localStorage, STORAGE.artworkHistory, {});
var parts = [];
Object.keys(history || {}).forEach(function (key) {
var item = history[key];
if (item && item.count) parts.push([item.artwork_title || key, item.count, item.last_viewed_at || ''].join(':'));
});
return parts.slice(-10).join('|');
}
function trackRepeatArtworkView() {
if (PAGE.entity_type !== 'artwork' || !PAGE.artwork_id) return;
var history = readJson(localStorage, STORAGE.artworkHistory, {});
var key = String(PAGE.artwork_id);
var item = history[key] || { count: 0, first_viewed_at_ms: Date.now(), sent_known_repeat: false };
item.count += 1;
item.artwork_id = PAGE.artwork_id || '';
item.artwork_title = PAGE.artwork_title || '';
item.artist_name = PAGE.artist_name || '';
item.last_viewed_at = nowIso();
item.last_viewed_at_ms = Date.now();
history[key] = item;
writeJson(localStorage, STORAGE.artworkHistory, history);
var known = readJson(localStorage, STORAGE.knownProfile, null);
if (item.count >= 2 && known && known.email && !item.sent_known_repeat) {
item.sent_known_repeat = true;
history[key] = item;
writeJson(localStorage, STORAGE.artworkHistory, history);
maddoxTrack('repeat_artwork_viewed', { email: known.email, artwork_id: PAGE.artwork_id || '', artwork_title: PAGE.artwork_title || '',
artist_name: PAGE.artist_name || '', view_count_7_days: item.count, known_user: true }, { dedupe_seconds: 7 * 24 * 60 * 60 });
}
}
function trackBaselineViews() {
maddoxTrack('page_viewed', pageEntityPayload(), { klaviyo: false, dedupe_seconds: 1800 });
if ((getSession().page_count || 1) === 1) maddoxTrack('landing_page_viewed', { landing_page: getSession().landing_page ||
window.location.href, channel_group: getAttributionBundle().channel_group || '' }, { klaviyo: false, dedupe_seconds: 60 });
}
function handleExternalLead(eventName, detail) {
detail = detail || {};
var mapped = text(eventName || detail.event_name || '', 120);
if (!mapped) return;
var payload = basePayload(Object.assign({}, detail, { event_name: mapped, event_source: detail.event_source ||
'external_confirmed_signal', dedupe_key: detail.dedupe_key || [mapped, detail.email || detail.phone || '', detail.booking_id || detail.chat_id ||
detail.submission_id || '', getPath()].join('|') }));
if (payload.email) identifyKnownUser(payload);
maddoxTrack(mapped, payload, { dedupe_seconds: 30 });
}

function initExternalLeadHooks() {
window.MADDOX_TRACK_CONFIRMED_LEAD = function (eventName, properties) { handleExternalLead(eventName, properties || {}); };
['chatbot_lead_created', 'appointment_booked', 'booking_started', 'lead_form_submitted'].forEach(function (name) {
window.addEventListener('maddox:' + name, function (event) { handleExternalLead(name, event.detail || {}); }, true);
});
}
function trackKnownLeadReturned() {
var known = readJson(localStorage, STORAGE.knownProfile, null);
if (!known || !known.identified_at) return;
var ageMs = Date.now() - Date.parse(known.identified_at || nowIso());
if (ageMs < 60 * 1000) return;
maddoxTrack('known_lead_returned', { known_user: true, lead_type: known.lead_type || '', days_since_last_visit: Math.floor(ageMs /
86400000), last_interest_area: PAGE.entity_type || '' }, { dedupe_seconds: 86400 });
}
function initMutationHydration() {
if (typeof MutationObserver === 'undefined') return;
var timer = null;
var observer = new MutationObserver(function () {
if (timer) clearTimeout(timer);
timer = setTimeout(function () {
hydrateAllForms(document);
if (window.MADDOX_FORM_VIEW_OBSERVER) {
Array.prototype.forEach.call(document.querySelectorAll('form'), function (form) {
if (isLeadForm(form)) window.MADDOX_FORM_VIEW_OBSERVER.observe(form);
});
}
}, 150);
});
observer.observe(document.documentElement, { childList: true, subtree: true });
}
function initKlaviyoSignals() {
window.addEventListener('klaviyoForms', function (event) { handleKlaviyoSignal(event.detail || {}, 'klaviyoForms'); }, true);
window.addEventListener('klaviyo:form:submit', function (event) { handleKlaviyoSignal(event.detail || {}, 'klaviyo_form_submit'); }, true);
window.addEventListener('klaviyo:form:success', function (event) { handleKlaviyoSignal(event.detail || {}, 'klaviyo_form_success'); }, true);
}
function init() {
getAnonymousId();
getSession();
incrementSessionPageCount();
captureAttribution();
trackBaselineViews();
hydrateAllForms(document);
observeLeadForms();
trackPageIntent();
trackKnownLeadReturned();
initKlaviyoSignals();
initExternalLeadHooks();
initMutationHydration();
document.addEventListener('submit', onFormSubmit, true);
document.addEventListener('input', onFormStarted, true);
document.addEventListener('change', onFormStarted, true);
document.addEventListener('focusin', onFormStarted, true);
document.addEventListener('invalid', onFormInvalid, true);
document.addEventListener('click', onClick, true);
window.addEventListener('pagehide', trackLeadFormAbandonment, true);
window.MADDOX_TRACK_EVENT = maddoxTrack;
window.MADDOX_BUILD_FORM_PAYLOAD = function (form) { return buildFormPayload(form, null, true); };
window.MADDOX_ENRICH_FORMS = function () { hydrateAllForms(document); };
window.MADDOX_TRACKING_VERSION = VERSION;
window.MADDOX_DEBUG_TRACKING = function () {
return {
version: VERSION,
pageContext: PAGE,
events: (window.MADDOX_TRACKING_EVENTS || []).slice(-30),
suppressedEvents: window.MADDOX_SUPPRESSED_TRACKING_EVENTS || [],
attribution: {
firstSeen: readJson(localStorage, STORAGE.firstSeen, null),
firstTouch: readJson(localStorage, STORAGE.firstTouch, null),
latestTouch: readJson(localStorage, STORAGE.latestMeaningfulTouch, null),
sessionTouch: readJson(sessionStorage, STORAGE.sessionTouch, null)
},
session: readJson(sessionStorage, STORAGE.session, null),
knownProfile: readJson(localStorage, STORAGE.knownProfile, null),
anonymousId: localStorage.getItem(STORAGE.anonymousId),
formState: readFormStates()
};
};
window.MADDOX_RESET_TRACKING_TEST_STATE = function () {
Object.keys(STORAGE).forEach(function (k) {

try { localStorage.removeItem(STORAGE[k]); } catch (e) {}
try { sessionStorage.removeItem(STORAGE[k]); } catch (e) {}
});
window.MADDOX_TRACKING_EVENTS = [];
window.MADDOX_SUPPRESSED_TRACKING_EVENTS = [];
eventDedupe = {};
log('test state reset');
};
log('initialised');
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
else init();
})();
